"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _SVGIcon = _interopRequireDefault(require("@instructure/ui-svg-images/lib/components/SVGIcon"));

var _ref =
/*#__PURE__*/
_react.default.createElement("path", {
  d: "M1743.858 267.012L710.747 1300.124 176.005 765.382 0 941.387l710.747 710.871 1209.24-1209.116z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconCheck =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(IconCheck, _Component);

  function IconCheck() {
    (0, _classCallCheck2.default)(this, IconCheck);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(IconCheck).apply(this, arguments));
  }

  (0, _createClass2.default)(IconCheck, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_SVGIcon.default, Object.assign({}, this.props, {
        name: "IconCheck",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);
  IconCheck.displayName = "IconCheck";
  return IconCheck;
}(_react.Component);

exports.default = IconCheck;
IconCheck.glyphName = 'check';
IconCheck.variant = 'Solid';
IconCheck.propTypes = (0, _objectSpread2.default)({}, _SVGIcon.default.propTypes);